<template>
  <qc-container :title="title">
    <page-request ref="table" url="/api/mgr/business/user/relative/list" :table-header="tableHeader" :expend="expend"  :prop="{userId:userId}" :op-width="100">
    </page-request>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import PageRequest from "@/components/base/page-request.vue";

export default {
  name: "user-relative",
  components: {PageRequest, QcContainer},
  props:{
    userId:{
      type:String,
      default:""
    },
    title:{
      type:String,
      default:"亲友信息"
    }
  },
  data() {
    return {
      tableHeader: [
        {prop: "name", label: "姓名",width: 100},
        {prop: "genderDesc", label: "性别",width: 100},
        {prop: "relationshipTypeDesc", label: "关系",width: 100},
        {prop: "age", label: "年龄",width: 100},
        {prop: "createTime", label: "创建时间"},
      ],
      expend:[
        {label: "亲友名称",prop: "name"},
        {label: "性别", prop: "gender",type:"select",options:[{"label":"女","value":"0"},{"label":"男","value":"1"}]},
      ]
    }
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>

<style scoped>

</style>
